<div class="page home">
	<div class="section home-about_us-item">
		<a class="home-about_us-link" href="#!/about_us">
			<div class="content">
				<p class="title">¿Quiénes somos?</p>
				<p>APROMAR es una asociación que trabaja de forma
					grupal la socialización y el cambio en la población reclusa más
					sensible, durante o después del cumplimiento de la pena, añadiendo
					la acogida como elemento de reinserción.</p>
				<p>Se constituye como una entidad privada sin fines
					lucrativos, que surge a partir de la iniciativa ciudadana para el
					beneficio de la comunidad. Somos, por tanto, independientes de la
					administración pública.</p>
			</div>
		</a>
	</div>
	<div class="section home-news-container">
		<div class="title">Novedades</div>
		<a class="home-news-link" id="20170106_01" href="#!/news#20170106_01">
			<div class="news-item">
				<div class="news-header">
					<div class="news-date">06-01-2017</div>
					<div class="news-title title">Entrevista a Ángeles Pérez - Cadena SER</div>
					<div class="news-subtitle subtitle">Con motivo del Concierto Benéfico de Reyes Amaral / Banda Sinfónica Municipal Madrid</div>
				</div>
				<div class="news-content content">
					<iframe src="http://play.cadenaser.com/widget/audio/cadenaser_hora25_20170106_210000_220000"  width="100%"  height="102" frameborder="0" allowfullscreen></iframe>
				</div>
			</div>
		</a>
		<a class="home-news-link" id="20170105_01" href="#!/news#20170105_01">
			<div class="news-item">
				<div class="news-header">
					<div class="news-date">05-01-2017</div>
					<div class="news-title title">Concierto benéfico Reyes - Aparición en Cadena SER</div>
					<div class="news-subtitle subtitle">Amaral / Banda Sinfónica Municipal Madrid</div>
				</div>
				<div class="news-content content">
					<iframe src="http://play.cadenaser.com/widget/audio/001RD010000004409218" width="100%" height="102" frameborder="0" allowfullscreen></iframe>
				</div>
			</div>
		</a>
		<div class="news-item">
			<div class="news-header">
				<div class="news-date">05-01-2017</div>
				<div class="news-title title">Concierto Benéfico de Reyes</div>
				<div class="news-subtitle subtitle">Amaral / Banda Sinfónica Municipal Madrid</div>
			</div>
			<div class="news-content content">
				<iframe width="560" height="315" src="https://www.youtube.com/embed/AnlSzxiEf9A" frameborder="0" allowfullscreen></iframe>
			</div>
		</div>
		<a class="home-news-link" id="20170101_01" href="#!/news#20170101_01">
			<div class="news-item">
				<div class="news-header">
					<div class="news-date">01-01-2017</div>
					<div class="news-title title">Concierto Benéfico de Reyes</div>
					<div class="news-subtitle subtitle">Amaral / Banda Sinfónica Municipal Madrid</div>
				</div>
				<div class="news-content content">
					<p>El grupo de música Amaral y la Banda Sinfónica Municipal de Madrid, cuyo titular es Rafael Sanz-Espert, compartirán escenario en el tradicional concierto de Reyes del 5 de enero de 2017. El evento forma parte de la programación de Navidad del Área de Cultura y Deportes. Se celebra en el Teatro Real, a las 12 horas. De carácter solidario, la actuación de este año es a beneficio de APROMAR, una asociación que trabaja para la integración y acogida de la población reclusa. <strong>[...]</strong></p>
				</div>
			</div>
		</a>
	</div>
</div>